// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useAuth = () => {
	const { auth, isLoading } = useSelector((state) => state.auth);

	return { isLoading, auth };
};

export const ProtectedAdminRoute = ({ children }) => {
	const { isLoading, auth } = useAuth();

	if (isLoading) {
		return (
			<div className='fixed inset-0 overflow-hidden w-full h-full flex justify-center items-center z-50'>
				<div>Loading....</div>
			</div>
		);
	}

	if (auth?.role !== 'ADMIN') {
		return <Navigate to='/' replace />;
	}

	return children;
};

export const ProtectedUserRoute = ({ children }) => {
	const { isLoading, auth } = useAuth();

	if (isLoading) {
		return (
			<div className='fixed inset-0 overflow-hidden w-full h-full flex justify-center items-center z-50'>
				<div>Loading....</div>
			</div>
		);
	}

	if (auth?.role !== 'USER') {
		return <Navigate to='/' replace />;
	}

	return children;
};
